// Example Node.js backend function
import axios from 'axios';

  const appId = process.env.REACT_APP_ONESIGNAL_APP_ID;
  const apiKey = process.env.REACT_APP_ONESIGNAL_API_KEY;

async function addEmailToSubscription(email) {
  try {
    const response = await axios.post(
      'https://onesignal.com/api/v1/players',
      {
        app_id: appId,
        device_type: 11, // 11 = Email
        identifier: email
      },
      {
        headers: {
          'Authorization': `Basic ${apiKey}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('OneSignal API error:', error.response?.data || error.message);
    return false;
  }
}

async function removeEmailFromSubscription(email) {
    try {
        // First, find the playerId by email
        const searchResponse = await axios.post(
            'https://onesignal.com/api/v1/players',
            {
                app_id: appId,
                device_type: 11,
                identifier: email
            },
            {
                headers: {
                    'Authorization': `Basic ${apiKey}`,
                    'Content-Type': 'application/json'
                }
            }
        );

        const playerId = searchResponse.data.id;
        if (!playerId) {
            console.error('Player not found for email:', email);
            return false;
        }

        // Unsubscribe using playerId
        const response = await axios.put(
            `https://onesignal.com/api/v1/players/${playerId}`,
            {
                app_id: appId,
                notification_types: -2 // Unsubscribe from all
            },
            {
                headers: {
                    'Authorization': `Basic ${apiKey}`,
                    'Content-Type': 'application/json'
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('OneSignal API error:', error.response?.data || error.message);
        return false;
    }
}

export { addEmailToSubscription, removeEmailFromSubscription };